import { TownsquareSiteAri, PlatformSiteAri } from '@atlassian/ari';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import ProjectViewAggInnerQuery, {
	type ProjectViewAggInnerQuery as ProjectViewAggInnerQueryType,
} from '../components/__generated__/ProjectViewAggInnerQuery.graphql';

export const createPlatformSiteAri = (siteId: string): string => {
	try {
		return PlatformSiteAri.create({ siteId }).toString();
	} catch {
		// No valid Platform site ari
		throw new Error('No Platform Site Ari');
	}
};

export const aggProjectViewResource = createRelayResource<ProjectViewAggInnerQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const projectKey = routerContext.match.params.id ?? '';

		const rawCloudId = context.workspace?.cloudId;
		if (!rawCloudId) throw new Error('No cloudId available');
		const containerId = TownsquareSiteAri.create({ siteId: rawCloudId }).toString();

		return {
			query: ProjectViewAggInnerQuery,
			variables: {
				projectKey,
				containerId,
				cloudId: rawCloudId,
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
